import styled from "styled-components";

const Bold = styled.strong`
  color: rgba(0, 0, 0, 0.8);
`;

export default Bold;
